import {FC, useCallback, useEffect, useState} from 'react'
import {SubClient} from '../../../../../services/cellcast.v2.types'
import {useLazyGetSubClientTransactionHistoryQuery} from '../../../../../services/cellcast.v2'
import NodataYet from '../../../../Components/NodataYet'
import Select from 'react-select'
import {Spinner} from 'react-bootstrap'
import moment from 'moment-timezone'
import ReactPaginate from 'react-paginate'
import { FixedTwoDecimal } from '../../../../Utils/_helpers/string'

export type CreditHistoryProps = {
  reload: boolean
  user: SubClient | undefined
}

const CreditHistory: FC<CreditHistoryProps> = (props) => {
  const {user, reload: parentReload} = props
  const statusOptions = [
    {value: '', label: ' status '},
    {value: 'credit', label: 'Credit'},
    {value: 'debit', label: 'Debit'},
  ]
  const typeOptions = [
    {value: '', label: ' type '},
    {value: 'sms', label: 'SMS'},
    {value: 'mms', label: 'MMS'},
  ]

  const [fetchData, {data, isLoading, isFetching}] = useLazyGetSubClientTransactionHistoryQuery()

  // local state
  const [params, setParams] = useState({
    page: 1,
    limit: 10,
    campType: '',
    status: '',
  })
  const [reload, setReload] = useState<boolean>(true)
  const [loadedData, setLoadedData] = useState<{
    startLoad: number
    endLoad: number
  }>({
    startLoad: 0,
    endLoad: 0,
  })

  const getLoadedData = useCallback(
    (
      page: string | number | undefined,
      limit: string | number | undefined,
      totalData: number
    ): {
      startLoad: number
      endLoad: number
    } => {
      let loadedPage = 1
      if (typeof page === 'string') {
        loadedPage = parseInt(page) || 1
      }

      if (typeof page === 'number') {
        loadedPage = page || 1
      }

      let loadedLimit = 10
      if (typeof limit === 'string') {
        loadedLimit = parseInt(limit) || 1
      }

      if (typeof limit === 'number') {
        loadedLimit = limit || 10
      }

      const startItem = (loadedPage - 1) * loadedLimit + 1
      const endItem = Math.min(loadedPage * loadedLimit, totalData)

      return {
        startLoad: startItem,
        endLoad: endItem,
      }
    },
    []
  )

  useEffect(() => {
    if (reload && user) {
      fetchData({
        id: user._id,
        data: params,
      })
      setReload(false)
    }
  }, [reload, user])

  // listed fetch data
  useEffect(() => {
    if (data) {
      const loadedData = getLoadedData(
        data && data.data.current ? data.data.current : 1,
        params.limit,
        data && data.data.total ? data.data.total : 0
      )
      setLoadedData(loadedData)
    }
  }, [isLoading, isFetching])

  useEffect(() => {
    if(parentReload && !isFetching){
      setReload(true)
    }
  }, [parentReload])

  return (
    <div className='card'>
      <div className='card-header border-0 py-5 px-8'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-2 mb-1'>Credit History</span>
          <span className='text-muted mt-1 fw-bold fs-7'>Ordered by the most recent</span>
        </h3>

        <div className='d-flex justify-content-end col-6'>
          <div className='col-md-6'>
            <Select
              placeholder='Select transaction'
              value={statusOptions.find((el) => el.value === params.status) || statusOptions[0]}
              options={statusOptions}
              onChange={(e: any) => {
                setParams({...params, status: e.value, page: 1})
                setReload(true)
              }}
            />{' '}
          </div>
          <div className='col-md-6 ms-2'>
            <Select
              placeholder='Select type'
              value={typeOptions.find((el) => el.value === params.campType) || typeOptions[0]}
              options={typeOptions}
              onChange={(e: any) => {
                setParams({...params, campType: e.value, page: 1})
                setReload(true)
              }}
            />
          </div>
        </div>
      </div>

      {isLoading ? (
        <div className='row flex-center h-200 mb-10'>
          <Spinner />
        </div>
      ) : (
        <>
          {data?.data?.items && data.data.items.length > 0 ? (
            <div className='card-body px-8 py-0 mb-5'>
              <div className='table-responsive'>
                <table className='table align-middle gs-0 gy-5 credit_history_table'>
                  <thead>
                    <tr className='fw-bolder text-muted'>
                      <th>Date</th>
                      <th>Type</th>
                      <th>Description</th>
                      <th>Note</th>
                      <th>Credits</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isFetching ? (
                      <tr>
                        <td colSpan={5} className='text-center'>
                          <Spinner />
                        </td>
                      </tr>
                    ) : (
                      <>
                        {data?.data?.items?.map((key: any, i: number) => (
                          <tr key={i}>
                            <td> {moment(key?.createdAt).format('DD-MM-YYYY HH:mm:ss')}</td>
                            <td className='table-row-gray-200'>
                              <span
                                className={
                                  key?.type === 'sms'
                                    ? 'badge badge-light-success green_text_badge badge-square p-4 w-50px py-5'
                                    : 'badge badge-light-info fs-7 blue_text_badge badge-square p-4 w-50px py-5'
                                }
                              >
                                {key?.type?.toUpperCase()}
                              </span>
                            </td>
                            <td>{key?.description}</td>
                            <td>{key?.note}</td>
                            <td className='table-row-gray-200'>
                              <a
                                className={`badge  ${
                                  key?.status == 'debit' ? 'red_text_badge' : 'green_text_badge'
                                }  `}
                              >
                                {key?.status == 'debit' ? '-' : ''}
                                {FixedTwoDecimal(key?.creditAmount || 0)}
                              </a>
                            </td>
                          </tr>
                        ))}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
              <div className='abcd'>
                <select
                  onChange={(e: any) => {
                    setParams({...params, limit: e.target.value})
                    setReload(true)
                  }}
                >
                  <option value={10} selected={params.limit === 10}>
                    10
                  </option>
                  <option value={20} selected={params.limit === 20}>
                    20
                  </option>
                  <option value={50} selected={params.limit === 50}>
                    50
                  </option>
                </select>
                {isFetching
                  ? '. . . . .'
                  : `Show ${loadedData.startLoad} - ${loadedData.endLoad} of ${
                      data.data.total ? data.data.total : 0
                    } data`}
                <ReactPaginate
                  previousLabel='<'
                  nextLabel='>'
                  pageCount={data?.data?.totalPages}
                  onPageChange={(e: any) => {
                    setParams({...params, page: e.selected + 1})
                    setReload(true)
                  }}
                  containerClassName={'pagination'}
                  previousLinkClassName={'pagination__link'}
                  nextLinkClassName={'pagination__link'}
                  disabledClassName={'pagination__link--disabled'}
                  activeClassName={'pagination__link--active'}
                />
              </div>
            </div>
          ) : (
            <>
              {isFetching ? (
                <div className='row flex-center h-200'>
                  <Spinner />
                </div>
              ) : (
                <NodataYet message={'No data yet'} />
              )}
            </>
          )}
        </>
      )}
    </div>
  )
}

export default CreditHistory
